<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dataset">
  <div class="provider-dataset--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-dataset--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-dataset--sidebar"></app-provider-sidebar>
    <div class="provider-dataset--content">
      <app-page-header></app-page-header>
      <div class="dataset-container">
        <!-- Step 2 Template -->
        <ng-template #step2Template>
          <form [formGroup]="metadataForm">
            <div class="step-content">
              <h2 class="step-title">Enter Metadata</h2>
              
              <!-- Dataset Information Fields (Disabled) -->
              <div *ngIf="datasetData" class="form-fields">
                <div class="form-row">
                  <!-- Title Field (Disabled) -->
                  <div class="form-field col-6">
                    <label for="dataset-title" class="form-label">
                      Title <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-title"
                      [value]="datasetData.title"
                      class="form-input"
                      disabled
                    />
                  </div>

                  <!-- Permission Field (Disabled) -->
                  <div class="form-field col-6">
                    <label for="dataset-permission" class="form-label">
                      Permission <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="dataset-permission"
                      [value]="getPermissionDisplayLabel(datasetData.permission)"
                      class="form-input"
                      disabled
                    />
                  </div>
                </div>
                
                <!-- HR Line -->
                <hr class="form-divider" />
              </div>

              <!-- For Models: Description Fields, Industry and License -->
              <ng-container *ngIf="isModel()">
                <!-- Description Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Short Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="short-description" class="form-label">
                        Short Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="short-description"
                          formControlName="shortDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a brief description of the model"
                          [maxlength]="getShortDescriptionMaxLength()"
                          [class.error]="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getShortDescriptionLength() >= getShortDescriptionMaxLength()">
                          {{ getShortDescriptionLength() }}/{{ getShortDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['required']">Short description is required</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['minlength']">Short description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['maxlength']">Short description cannot exceed {{ getShortDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>

                    <!-- Long Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="long-description" class="form-label">
                        Long Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="long-description"
                          formControlName="longDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a detailed description of the model"
                          [maxlength]="getLongDescriptionMaxLength()"
                          [class.error]="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getLongDescriptionLength() >= getLongDescriptionMaxLength()">
                          {{ getLongDescriptionLength() }}/{{ getLongDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['required']">Long description is required</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['minlength']">Long description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['maxlength']">Long description cannot exceed {{ getLongDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Industry and License Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Industry Field -->
                    <div class="form-field col-6">
                      <label for="industry" class="form-label">
                        Industry <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="metadataForm.get('industry')?.invalid && metadataForm.get('industry')?.touched"
                          [class.open]="isIndustryDropdownOpen"
                          (click)="toggleIndustryDropdown()"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get('industry')?.value" class="placeholder">Select industry</span>
                            <span *ngIf="metadataForm.get('industry')?.value" class="selected-value">
                              {{ getSelectedIndustryLabel() }}
                            </span>
                            <svg class="dropdown-arrow" [class.open]="isIndustryDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" [class.panel-open-upward]="isIndustryDropdownUpward" *ngIf="isIndustryDropdownOpen">
                          <div
                            *ngFor="let option of industryOptions"
                            class="dropdown-option"
                            [class.selected]="isIndustrySelected(option.value)"
                            (click)="selectIndustry(option)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isIndustrySelected(option.value)"></div>
                            </div>
                            <span class="option-label">{{ option.label }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="metadataForm.get('industry')?.invalid && metadataForm.get('industry')?.touched"
                        class="error-message"
                      >
                        Industry is required
                      </div>
                    </div>

                    <!-- License Field -->
                    <div class="form-field col-6">
                      <label for="license" class="form-label">
                        License <span class="required">*</span>
                      </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                        [class.open]="isLicenseDropdownOpen"
                        (click)="toggleLicenseDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!metadataForm.get('license')?.value" class="placeholder">Select license</span>
                          <span *ngIf="metadataForm.get('license')?.value && metadataForm.get('license')?.value !== 'Other'" class="selected-value">
                            {{ getSelectedLicenseLabel() }}
                          </span>
                          <span *ngIf="metadataForm.get('license')?.value === 'Other'" class="selected-value">
                            Other
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isLicenseDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" [class.panel-open-upward]="isLicenseDropdownUpward" *ngIf="isLicenseDropdownOpen">
                        <div
                          *ngFor="let option of licenseOptions"
                          class="dropdown-option"
                          [class.selected]="isLicenseSelected(option.value)"
                          (click)="selectLicense(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isLicenseSelected(option.value)"></div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                      class="error-message"
                    >
                      License is required
                    </div>
                  </div>

                      <!-- Other License Input (shown when "Other" is selected) -->
                      <div 
                        class="form-field col-6" 
                        *ngIf="isOtherLicenseSelected()"
                      >
                        <label for="other-license" class="form-label">
                          Specify License <span class="required">*</span>
                        </label>
                        <input
                          type="text"
                          id="other-license"
                          formControlName="otherLicense"
                          class="form-input"
                          placeholder="Enter license name"
                          [class.error]="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                        />
                        <div
                          *ngIf="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                          class="error-message"
                        >
                          Please specify the license name
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

              <!-- For Datasets: All Fields -->
              <ng-container *ngIf="!isModel()">
                <!-- Description Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Short Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="short-description" class="form-label">
                        Short Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="short-description"
                          formControlName="shortDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a brief description of the dataset"
                          [maxlength]="getShortDescriptionMaxLength()"
                          [class.error]="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getShortDescriptionLength() >= getShortDescriptionMaxLength()">
                          {{ getShortDescriptionLength() }}/{{ getShortDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('shortDescription')?.invalid && metadataForm.get('shortDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['required']">Short description is required</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['minlength']">Short description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('shortDescription')?.errors?.['maxlength']">Short description cannot exceed {{ getShortDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>

                    <!-- Long Description - 50% Width -->
                    <div class="form-field col-6">
                      <label for="long-description" class="form-label">
                        Long Description <span class="required">*</span>
                      </label>
                      <div class="textarea-wrapper">
                        <textarea
                          id="long-description"
                          formControlName="longDescription"
                          class="form-textarea"
                          rows="4"
                          placeholder="Enter a detailed description of the dataset"
                          [maxlength]="getLongDescriptionMaxLength()"
                          [class.error]="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        ></textarea>
                        <span class="character-count" [class.character-limit-reached]="getLongDescriptionLength() >= getLongDescriptionMaxLength()">
                          {{ getLongDescriptionLength() }}/{{ getLongDescriptionMaxLength() }} Characters
                        </span>
                      </div>
                      <div
                        *ngIf="metadataForm.get('longDescription')?.invalid && metadataForm.get('longDescription')?.touched"
                        class="error-message"
                      >
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['required']">Long description is required</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['minlength']">Long description must be at least 50 characters</span>
                        <span *ngIf="metadataForm.get('longDescription')?.errors?.['maxlength']">Long description cannot exceed {{ getLongDescriptionMaxLength() }} characters</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Year Range and Geo Coverage Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Year Range Field -->
                    <div class="form-field col-6">
                      <label for="year-range" class="form-label">
                        Year Range <span class="required">*</span>
                      </label>
                      <app-year-range-picker
                        formControlName="yearRange"
                        placeholder="Choose year range"
                        styleClass="form-select"
                      ></app-year-range-picker>
                      <div
                        *ngIf="metadataForm.get('yearRange')?.invalid && metadataForm.get('yearRange')?.touched"
                        class="error-message"
                      >
                        Year range is required
                      </div>
                    </div>

                    <!-- Geo Coverage Field -->
                    <div class="form-field col-6">
                      <label for="geo-coverage" class="form-label">
                        Geo Coverage <span class="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="geo-coverage"
                        formControlName="geoCoverage"
                        class="form-input"
                        placeholder="Enter geo coverage"
                        [class.error]="metadataForm.get('geoCoverage')?.invalid && metadataForm.get('geoCoverage')?.touched"
                      />
                      <div
                        *ngIf="metadataForm.get('geoCoverage')?.invalid && metadataForm.get('geoCoverage')?.touched"
                        class="error-message"
                      >
                        Geo coverage is required
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Resource Server and Upload Frequency Fields -->
                <div class="form-fields">
                  <div class="form-row">
                    <!-- Resource Server Field -->
                    <div class="form-field col-6">
                      <label for="resource-server" class="form-label">
                        Resource Server <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="metadataForm.get('resourceServer')?.invalid && metadataForm.get('resourceServer')?.touched"
                          [class.open]="isResourceServerDropdownOpen"
                          (click)="toggleResourceServerDropdown()"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get('resourceServer')?.value" class="placeholder">Select resource server</span>
                            <span *ngIf="metadataForm.get('resourceServer')?.value" class="selected-value">
                              <span class="selected-value-name">{{ getSelectedResourceServerName() }}</span>
                              <span class="selected-value-separator"> - </span>
                              <span class="selected-value-url">{{ getSelectedResourceServerUrl() }}</span>
                            </span>
                            <svg class="dropdown-arrow" [class.open]="isResourceServerDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" [class.panel-open-upward]="isResourceServerDropdownUpward" *ngIf="isResourceServerDropdownOpen">
                          <div
                            *ngFor="let option of resourceServerOptions"
                            class="dropdown-option"
                            [class.selected]="isResourceServerSelected(option.value)"
                            (click)="selectResourceServer(option)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isResourceServerSelected(option.value)"></div>
                            </div>
                            <div class="option-label-wrapper">
                              <div class="option-label-name">{{ option.name }}</div>
                              <div class="option-label-url">{{ option.url }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="metadataForm.get('resourceServer')?.invalid && metadataForm.get('resourceServer')?.touched"
                        class="error-message"
                      >
                        Resource server is required
                      </div>
                    </div>

                    <!-- Upload Frequency Field -->
                    <div class="form-field col-6">
                      <label for="upload-frequency" class="form-label">
                        Upload Frequency <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="metadataForm.get('uploadFrequency')?.invalid && metadataForm.get('uploadFrequency')?.touched"
                          [class.open]="isUploadFrequencyDropdownOpen"
                          (click)="toggleUploadFrequencyDropdown()"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get('uploadFrequency')?.value" class="placeholder">Select upload frequency</span>
                            <span *ngIf="metadataForm.get('uploadFrequency')?.value" class="selected-value">
                              {{ getSelectedUploadFrequencyLabel() }}
                            </span>
                            <svg class="dropdown-arrow" [class.open]="isUploadFrequencyDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" [class.panel-open-upward]="isUploadFrequencyDropdownUpward" *ngIf="isUploadFrequencyDropdownOpen">
                          <div
                            *ngFor="let option of uploadFrequencyOptions"
                            class="dropdown-option"
                            [class.selected]="isUploadFrequencySelected(option.value)"
                            (click)="selectUploadFrequency(option)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isUploadFrequencySelected(option.value)"></div>
                            </div>
                            <span class="option-label">{{ option.label }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="metadataForm.get('uploadFrequency')?.invalid && metadataForm.get('uploadFrequency')?.touched"
                        class="error-message"
                      >
                        Upload frequency is required
                      </div>
                    </div>
                  </div>
                </div>

                <!-- License Field -->
                <div class="form-fields">
                  <div class="form-row">
                    <div class="form-field col-6">
                      <label for="license" class="form-label">
                        License <span class="required">*</span>
                      </label>
                      <div class="custom-dropdown-wrapper">
                        <div
                          class="custom-dropdown-trigger"
                          [class.error]="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                          [class.open]="isLicenseDropdownOpen"
                          (click)="toggleLicenseDropdown()"
                        >
                          <div class="trigger-content">
                            <span *ngIf="!metadataForm.get('license')?.value" class="placeholder">Select license</span>
                            <span *ngIf="metadataForm.get('license')?.value && metadataForm.get('license')?.value !== 'Other'" class="selected-value">
                              {{ getSelectedLicenseLabel() }}
                            </span>
                            <span *ngIf="metadataForm.get('license')?.value === 'Other'" class="selected-value">
                              Other
                            </span>
                            <svg class="dropdown-arrow" [class.open]="isLicenseDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </div>
                        <div class="custom-dropdown-panel" [class.panel-open-upward]="isLicenseDropdownUpward" *ngIf="isLicenseDropdownOpen">
                          <div
                            *ngFor="let option of licenseOptions"
                            class="dropdown-option"
                            [class.selected]="isLicenseSelected(option.value)"
                            (click)="selectLicense(option)"
                          >
                            <div class="checkbox-wrapper">
                              <div class="checkbox-custom" [class.checked]="isLicenseSelected(option.value)"></div>
                            </div>
                            <span class="option-label">{{ option.label }}</span>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="metadataForm.get('license')?.invalid && metadataForm.get('license')?.touched"
                        class="error-message"
                      >
                        License is required
                      </div>
                    </div>

                    <!-- Other License Input (shown when "Other" is selected) -->
                    <div 
                      class="form-field col-6" 
                      *ngIf="isOtherLicenseSelected()"
                    >
                      <label for="other-license" class="form-label">
                        Specify License <span class="required">*</span>
                      </label>
                      <input
                        type="text"
                        id="other-license"
                        formControlName="otherLicense"
                        class="form-input"
                        placeholder="Enter license name"
                        [class.error]="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                      />
                      <div
                        *ngIf="metadataForm.get('otherLicense')?.invalid && metadataForm.get('otherLicense')?.touched && isOtherLicenseSelected()"
                        class="error-message"
                      >
                        Please specify the license name
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </form>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="stepperStepsWithLabel"
          [currentStep]="currentStep"
          [disableNextButton]="!isMetadataFormValid()"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>
</div>

